import axios from 'axios';

// Create an Axios instance
const api = axios.create({
    // Fallback to localhost if REACT_APP_API_URL is not set in .env
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000',
    timeout: 10000,
    headers: {
        
    }
});

// Request Interceptor
api.interceptors.request.use(
    (config) => {
        // You can attach tokens here before the request is sent
        const adminToken = localStorage.getItem('admin');
        if (adminToken) {
            // If you are using JWT or similar token-based auth
            // config.headers.Authorization = `Bearer ${adminToken}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response Interceptor
api.interceptors.response.use(
    (response) => {
        // Any status code within the range of 2xx causes this function to trigger
        return response;
    },
    (error) => {
        // Any status codes outside the range of 2xx cause this function to trigger
        if (error.response && error.response.status === 401) {
            // Handle unauthorized errors (e.g., redirect to login, clear local storage)
            console.error('Unauthorized! Token may have expired.');
            localStorage.removeItem('admin');
            window.location.href = '/'; 
        }
        return Promise.reject(error);
    }
);

export default api;
